(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('.js-notify-availability') : null;

    if (!trigger) {
      return;
    }

    var modal = document.getElementById('app-product-availability-notify');

    if (!modal || !window.jQuery) {
      return;
    }

    e.preventDefault();
    window.jQuery(modal).modal('show', trigger);
  });
}());
